const SET_RETURN_TO = 'preferences/SET_RETURN_TO'
const CLEAR_RETURN_TO = 'preferences/CLEAR_RETURN_TO'
const SET_APP_PREFERENCES = 'preferences/SET_APP_PREFERENCES'
const DISMISS_MAINTENANCE = 'preferences/DISMISS_MAINTENANCE'

// Each of the following action types should
// trigger a "persist" to localStorage via middleware.
export const SAVE_TYPES = Object.freeze([
    SET_APP_PREFERENCES,
    DISMISS_MAINTENANCE,
    SET_RETURN_TO,
    CLEAR_RETURN_TO,
])

export const FABRICATE = 'Fabricate'
export const QUOTES = 'Quotes'
export const ORDERS = 'Orders'
export const QUOTES_ORDERS = 'My quotes & orders'
export const QUOTES_MANAGER = 'Quotes Manager'
export const WORKBENCH_JOBS = 'Jobs'
export const ADMIN = 'Admin'
export const OPERATIONS = 'Operations'
export const ACCOUNT = 'Account'
export const INTERNAL_TOOLS = 'Internal tools'
export const SEARCH = 'Search'

export const RESELLER = 'reseller'

export const LOGIN_PATH = '/login'
export const SIGNUP_PATH = '/signup'
export const SIGN_IN_PATH = '/users/sign_in'
export const QUOTES_PATH = '/pages/quotes'
export const TEAM_PATH = '/pages/team'
export const CHECKOUT_PATH = '/pages/orders/quote'
export const BA_TEAM_MEMBERS_PATH = '/pages/my-account/team-members'
export const ADMIN_PATH = '/admin/app'
export const QMR_PATH = '/quote-model-revision'
export const OPERATIONS_PATH = '/admin/app/operations'
export const OPS_PRODUCTION_PATH = '/admin/app/operations/production'
export const OPS_SCHEDULING_PATH = '/admin/app/operations/scheduling'
export const OPS_QUALITY_PATH = '/admin/app/operations/quality'
export const WORKBENCH_JOBS_PATH = '/workbench'
export const PRODUCTION_PATH = '/admin/app/production'
export const MFG_PARTNER_PATH = '/admin/app/operations/mfgPartners'

export const ORDERS_PATH = '/orders'
export const ADMIN_403_PATH = '/403'
export const getOboUserQuotesHomePagePath = userId =>
    `/admin/app/user/${userId}/quotes`
export const EXPORT_CONTORL_QUERY_STRING = 'acceptedTerms=true'

const initialState = {
    appPreference: {},
    maintenanceNoticeDismissed: false,
    returnTo: null,
}

export default function preferences(state = initialState, action) {
    switch (action.type) {
        case SET_APP_PREFERENCES:
            return {
                ...state,
                appPreference: {
                    ...state.appPreference,
                    [action.userId]: action.appPreference,
                },
            }
        case DISMISS_MAINTENANCE:
            return {
                ...state,
                maintenanceNoticeDismissed: true,
            }
        case SET_RETURN_TO:
            return {
                ...state,
                returnTo: action.payload,
            }
        case CLEAR_RETURN_TO:
            return {
                ...state,
                returnTo: null,
            }
        default:
            return state
    }
}

export function getPreferredAppRedirectPath(state) {
    const appPreference = state.preferences.appPreference[state.identity.id]

    if (appPreference === ADMIN) {
        return ADMIN_PATH
    } else if (appPreference === OPERATIONS) {
        return `${OPS_PRODUCTION_PATH}/salesOrders`
    }
    return QUOTES_PATH
}

export function clearReturnTo() {
    return { type: CLEAR_RETURN_TO }
}

export function setAppPreferences(userId, appPreference) {
    return {
        type: SET_APP_PREFERENCES,
        userId,
        appPreference,
    }
}
